import { Button, Icon, Tooltip } from '@boltenergy-be/design-system'
import { EditingButtonProps } from './types'
import { useTranslation } from 'react-i18next'

const EditingButton = ({ isDisabled, isEditing, setIsEditing, isLoading, onSubmit, identifier, onCancel }: EditingButtonProps) => {
  //i18n
  const { t } = useTranslation(['common', 'sales'])

  return !isEditing ? (
    <li>
      <Button aria-label="edit" type="button" variant="tertiary" disabled={isDisabled} onClick={() => setIsEditing(identifier)}>
        <Tooltip
          tooltipContent={t(($) => $.details.tooltips.edit, {
            ns: 'sales'
          })}
          open={isDisabled ? false : undefined}
          asChild
        >
          <span>
            <Icon name="pencil" />
          </span>
        </Tooltip>
      </Button>
    </li>
  ) : (
    <>
      <li>
        <Button
          variant="secondary"
          type="button"
          onClick={() => {
            onCancel()
            setIsEditing(undefined)
          }}
          disabled={isLoading}
        >
          {t(($) => $.cancel)}
        </Button>
      </li>
      <li>
        <Button type="button" loading={isLoading} onClick={onSubmit}>
          {t(($) => $.save)}
        </Button>
      </li>
    </>
  )
}

export default EditingButton
